import { useTheme } from '@mui/material/styles';

export const useSignInCardStyles = () => {
  const theme = useTheme();
  return {
    root: {
      marginTop: theme.spacing(1),
    },
    col: {
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'start',
    },
    headingSignedIn: {
      color: 'white',
      backgroundColor: theme.palette.success.main,
      '&:hover': {
        background: theme.palette.success.main,
      },
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    headingNotSignedIn: {
      color: 'white',
      backgroundColor: theme.palette.info.main,
      '&:hover': {
        background: theme.palette.info.main,
      },
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    euLogo: {
      width: "30px",
      marginTop: "5px"
    }
  };
};